import script from "./TicketCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketCalendar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__